define(
    ['underscore', 'text!./templates/basler-company-search.html'],
    (_, templateStr) => {

        return ['BaslerCompanySearchService', 'DefaultErrorHandlerService',
            function (BaslerCompanySearchService, DefaultErrorHandlerService) {
            return {
                restrict: 'E',
                template: templateStr,
                scope: {
                    callbackNewCompany: '=',
                    callbackSelectedCompany: '=',
                    callbackNewSearch: '=',
                    postalCode: '=',
                    city: '=',
                    canton: '=',
                },
                link: function ($scope) {

                    $scope.searchTerm = '';
                    $scope.companies = [];
                    $scope.showResults = false;
                    $scope.selectedCompany = { value: null }; //note: requires an object to pass reference
                    $scope.callGroups = 'companysearch';
                    $scope.postCodeAndCityParam = { postCodeAndCity: `${$scope.postalCode} ${$scope.city}` };

                    $scope.callCompanySearchService = function (searchTerm) {
                        //reset variables
                        $scope.showResults = false;
                        $scope.selectedCompany = { value: null};

                        //reset all company fields
                        $scope.callbackNewSearch();

                        if (searchTerm) {
                            const isoCode = $scope.canton && $scope.canton.code === 'CH_FL' ? 'LI' : 'CH'
                            BaslerCompanySearchService.find($scope.callGroups, $scope.postalCode, searchTerm, isoCode)
                                .then((result) => {
                                    $scope.companies = result.filter((it) => {
                                        const postalCode = it && it.primaryAddress && it.primaryAddress.postalCode;
                                        return postalCode === $scope.postalCode;
                                    });
                                    $scope.showResults = true;
                                }, (error) => {
                                    //on search error - show link to create manual company creation
                                    $scope.showResults = true;
                                    DefaultErrorHandlerService.getErrorHandlerForError(error)();
                                });
                        }
                    };

                    $scope.$watch('selectedCompany.value', () => {
                        if ($scope.selectedCompany.value) {
                            $scope.selectedCompany.value.emailAddress = $scope.selectedCompany.value.companyEmailAddress;
                            $scope.showResults = false;
                            $scope.callbackSelectedCompany($scope.selectedCompany.value);
                        }
                    });

                    $scope.onCreateCompany = function () {
                        $scope.showResults = false;
                        $scope.selectedCompany = { value: null};
                        $scope.callbackNewCompany();
                    };

                },
            };
        }];
    }
);




// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerCompanySearch.js